/* CONTEXT:START
Component: AddSubmissionButton
Status: build
Dependencies: Material-UI, SubmissionDialog
Next: integrate with Dashboard component
CONTEXT:END */

import React, { useState } from 'react';
import { Button, Paper, Typography, Box } from '@mui/material';
import { Add } from '@mui/icons-material';
import SubmissionDialog from './SubmissionDialog';

interface AddSubmissionButtonProps {
  month: number;
  year: number;
  onSubmissionCreated: () => void;
}

const AddSubmissionButton: React.FC<AddSubmissionButtonProps> = ({
  month,
  year,
  onSubmissionCreated,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleSubmissionCreated = () => {
    onSubmissionCreated();
  };

  const monthName = new Date(year, month - 1).toLocaleDateString('en-US', { 
    month: 'long', 
    year: 'numeric' 
  });

  return (
    <>
      <Paper sx={{ p: 3, width: '100%', minWidth: 'unset' }}>
        <Typography variant="h6" gutterBottom>
          Monthly Submissions
        </Typography>
        
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {monthName}
        </Typography>

        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={handleOpenDialog}
          fullWidth
          sx={{ 
            py: 1.5,
            fontSize: '1rem',
            fontWeight: 500,
          }}
        >
          Add New Submission
        </Button>

        <Box sx={{ mt: 2 }}>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
            Share your highlights and lowlights for this month
          </Typography>
        </Box>
      </Paper>

      <SubmissionDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        month={month}
        year={year}
        onSubmissionCreated={handleSubmissionCreated}
      />
    </>
  );
};

export default AddSubmissionButton;
